import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order } from "risa-data-model";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../api/firebase/references";
import { AppDispatch, DataState } from "../store/store";

const intialOrderState: DataState<Order> = {
  loading: false,
  error: null,
  data: null,
};

export const singleOrderSlice = createSlice({
  name: "singleOrderSlice",
  initialState: intialOrderState,
  reducers: {
    setSingleOrder(state: DataState<Order>, action: PayloadAction<Order>) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setLoading(state: DataState<Order>, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state: DataState<Order>, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    resetSingleOrder(state: DataState<Order>) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { setSingleOrder, setLoading, setError, resetSingleOrder } =
  singleOrderSlice.actions;

export const getOrderDetailsFor =
  (orderId: string) => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    const unsubscribe = FirestoreService.listenToDocument<Order>(
      FirestoreCollectionReference.orders(),
      orderId,
      (singleOrder) => {
        if (singleOrder) {
          dispatch(setSingleOrder(singleOrder));
        }
      },
      (error) => {
        dispatch(setError(error.message));
      },
    );

    return unsubscribe;
  };

export default singleOrderSlice.reducer;
